import { styled } from '@mui/material';

export const StyledIPEDSContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '90px',
  // TODO use color from library
  backgroundColor: '#F9F9F9',
}));

export const StyledIPEDSInner = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  maxWidth: '1816px',
  width: '100%',
  padding: '0.625rem 1rem',

  '& > span:first-of-type': {
    textAlign: 'center',
    marginBottom: '0.75rem',
  },
}));
